import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexBox, ImgWrap } from "../../styles/Common";
import arrow from "../../styles/images/ico_arrow_down.svg";
import { ReactComponent as IcoFile } from "../../styles/images/ico_notice_file.svg";
import { timeChange } from "../hooks/basicFunc";
import { useDispatch } from "react-redux";
import { serviceActions } from "../../store/slices/serviceSlice";
import NoticeDetail from "./NoticeDetail";

const NoticeList = (props) => {
  const { data } = props;

  return (
    <InquiryListWrap>
      <ul>
        {/* {data.list.main.map((li, index) => (
          <li key={"main" + index} className="pointer">
            <NoticeDetail data={li} />
          </li>
        ))} */}
        {data.list.search.map((li, index) => (
          <li className="list pointer" key={"search" + index}>
            <NoticeDetail data={li} />
          </li>
        ))}
      </ul>
    </InquiryListWrap>
  );
};

export default NoticeList;
const InquiryListWrap = styled.div`
  .list {
    border-radius: 1rem;
    padding: 2rem 1.5rem;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
    background-color: ${({ theme }) => theme.color.white};
    margin-top: 1rem;
    &:nth-of-type(1) {
      margin-top: 0;
    }
  }

  details[open] {
    summary {
      padding-bottom: 2rem;
      img {
        transform: rotate(180deg);
      }
      h4 {
        white-space: wrap;
        line-height: 1.6rem;
      }
    }
  }
`;
